exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ql-container .ql-editor {\n  min-height: 200px;\n  padding-bottom: 1rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/ng2-quill-editor/quillEditor.component.css
// module id = ../../../../ng2-quill-editor/quillEditor.component.css
// module chunks = 4